import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { map, type Observable } from 'rxjs';
import type { GetSupplierPropertiesResponseDto } from '../../insights/suppliers/models/supplier-properties.dto.models';
import { getSupplierPropertiesResponseSchema } from '../../insights/suppliers/models/supplier.models';
import { getDefaultSupplierPropertyTranslationKey } from '../../shared/helpers/get-default-supplier-property-translation-key/get-default-supplier-property-translation-key.helper';
import { ApiV2Service } from './api-v2.service';

@Injectable({ providedIn: 'root' })
export class PropertiesSharedService {
  readonly #apiV2Service = inject(ApiV2Service);
  readonly #translocoService = inject(TranslocoService);

  getSupplierProperties(
    accountId: number,
  ): Observable<GetSupplierPropertiesResponseDto> {
    return this.#apiV2Service
      .get<GetSupplierPropertiesResponseDto>({
        request: {
          url: {
            apiName: 'api',
            path: `/properties-account/${accountId}`,
          },
        },
        response: {
          schema: getSupplierPropertiesResponseSchema,
        },
      })
      .pipe(
        map((response) => {
          if (!response.status) {
            return response;
          }

          // NOTE: Apply translations to property labels
          return {
            ...response,
            data: Object.fromEntries(
              Object.entries(response.data).map(
                ([contentAreaId, properties]) => [
                  contentAreaId,
                  properties.map((property) => {
                    const defaultSupplierPropertyTranslationKey =
                      getDefaultSupplierPropertyTranslationKey(property.id);
                    if (defaultSupplierPropertyTranslationKey === undefined) {
                      return property;
                    }

                    return {
                      ...property,
                      label: this.#translocoService.translate(
                        defaultSupplierPropertyTranslationKey,
                      ),
                    };
                  }),
                ],
              ),
            ),
          };
        }),
      );
  }
}
